export default {
	config:{
		add:'添加',
		submit:'提交',
		cancel:'取消',
		noData:'暂无数据',
		delete:'删除',
		refresh:'刷新',
		back:'返回',
		send:'发送',
		deleteMessage:'此操作将永久删除，您要继续吗？',
		warnTitle:'警告',
		success:'提交成功!',
		warnFill:'请填写',
		warnNumber:'请输入一个数字',
		warnInvalid:'无效填写',
		start:'开始',
		confirm:'确认',
		goto:'请前往',
	},
	header:{
		changeLang:'选择语言',
		update:'更新',
		reset:'重启',
		logout:'退出',
	},
	welcome:{
		title:'欢迎使用GreenPacket CPE',
		button:'马上体验',
		recommend:'安装位置推荐',
		recomText:'安装设备前，建议先进行信号质量检测，以确定最优位置',
		next:'下一步',
		parsing:'安装步骤解析',
		step1:'步骤一',
		step1Text:'机身底部、确认插卡',
		step2:'步骤二',
		step2Text:'金属封盖、拧入卡槽',
		step3:'步骤三',
		step3Text:'拧紧封盖、防水防尘',
		step4:'步骤四',
		step4Text:'网线插入、密封套圈',
		step5:'步骤五',
		step5Text:'拧紧套圈、防水安全',
		step6:'步骤六',
		step6Text:'机身背面、插入喉箍',
		step7:'步骤七',
		step7Text:'扣入抱杆、拧紧固定',
		step8:'步骤八',
		step8Text:'调整角度、安装完成',
		find:'请调整设备方向或移动设备寻找最优的信号位置',
		nowSignal:'当前信号质量',
		score:'分',
		suggest:'建议使用当前位置或角度',
		continue:'继续监测',
		signalStrength:'信号强度',
		distributed:'检测记录分布情况',
		guide:'上网向导',
		guideSsid:'WLAN名称',
		guidePsw:'WLAN密码',
		samePsw:'设备登陆密码',
		sameText:'与WLAN密码相同',
		oldPsw:'用户旧密码',
		newPsw:'用户新密码',
		passwordRuleText:'密码格式：8-20位密码，必须包含大写和小写字母，数字和特殊字符',
		rules:{
			pwdMust:'请输入密码',
			pwdRule:'密码格式不正确',
		},
		finish:'完成',
		resetWait:'设备正在重启，请稍后',
		newWlanName:'新的WLAN名称为：',
		reloadPage:'如需管理您的地址，请在重启结束后重新访问管理地址',
	},
	login:{
		userName:'用户名',
		userPassword:'用户密码',
		loginBtn:'登录',
		forgetPsw:'忘记密码',
		resetText:'请长按 RESET 键恢复出厂设置(可能导致您的用户数据丢失),重新设置密码。',
	},
	menu:{
		home:'首页',
		mobilenet:'移动网络',
		easy:'WLAN简易设置',
		terminal:'终端管理',
		tools:'工具箱',
		sms:'SMS',
		settings:'高级设置',
		advanced:{
			DeviceInformation:'设备信息',
			NetworkMenu:{
				Network:'网络设置',
				APNManagement:'APN管理',
				DHCPSettings:'DHCP设置',
				LTEConfiguration:'LTE配置',
				CellSelection:'小区锁定',
				LockBand:'频点锁定',
				NetworkSelection:'网络选择',
				CommandShell:'Shell命令',
			},
			WiFiMenu:{
				WiFi:'Wi-Fi',
				WLANStatus:'WiFi状态',
				WLANSettings:'WiFi设置',
				WPS:'WPS',
				MACFILTER:'MAC过滤',
			},
			FirewallMenu:{
				Firewall:'防火墙',
				FirewallSettings:'防火墙设置',
				ALG:'ALG',
				PortForwarding:'端口转发',
				DMZsettings:'DMZ设置',
				UPnP:'UPnP',
				IPFiltering:'IP过滤',
				URLFiltering:'地址过滤',
				PortFiltering:'端口过滤',
			},
			SystemMenu:{
				System:'系统',
				Maintenance:'维护',
				DDNS:'DDNS',
				General:'通用设置',
				Ping:'Ping',
				Update:'升级',
				TR069:'TR069',
				Iperf:'Iperf',
			},
			VoiceMenu:{
				VoiceSettings:'语音设置',
				SIPSever:'SIP服务',
				DigitalMap:'数字地图',
			}
		},
	},
	home:{
		netStatusYes:'网络已连接',
		netStatusNo:'网络未连接',
		myDevice:'我的设备',
		devices:'连接设备',
		moreInternet:'更多网络设置',
		moreInfo:'更多设备信息',
		moreDevices:'终端管理',
	},
	mobileNetwork:{
		pageConnect:'移动网络设置',
		pageConnectInfo:{
			text:'接入点名称（APN）是您的设备读取的设置信息名称，该信息用于设置与运营商的移动网络和公共网络之间的网管 的连接。大多数情况下，您的设备已在系统文件中进行了这些设置，并且可以在链接自动填写的APN信息。',
			apnName:'APN名称',
			classId:'类别ID',
			IpType:'IP类型',
			auth:'认证',
			username:'用户名',
			password:'密码',
			up32:'最多32个字符',
			up64:'最多64个字符',
			MaxLimit:'最高限额:16',
			None:'None',
		},
		pageSearch:'移动网络搜索',
		pageSearchInfo:{
			text:'该设备支持“智能上网”，自动选择更优网络，上网体验更佳',
			NetworkingMode:'组网模式',
			InternetSearchMethod:'网络搜索方式',
		},
		search:'自动',
	},
	myDevicesInfo:{
		SystemInfomation:'系统信息',
		VersionInfomation:'版本信息',
		LANStatus:'局域网状态',
		RunningTime:'运行时间',
		ProductModel:'产品型号',
		HardwareVersion:'硬件版本',
		SoftwareVersion:'软件版本',
		SerialNumber:'序列号',
		MACAddress:'MAC地址',
		WanIP:'WAN IP地址',
		IPAddress:'IP地址',
		SubnetMask:'子网掩码',
	},
	devicesManage:{
		title:'终端管理',
		text:'展示与管理所有终端信息',
		WiFiStatus:'WLAN状态',
		Frequency:'频率（频道）',
		SecurityMode:'安全模式',
		DeviceList:'设备列表',
		onlineTable:'在线终端',
		outlineTable:'离线终端',
		allowNet:'允许上网',
		stopTime:'租约到期时间',
		editName:'修改名字',
		deleteText:'确定删除当前设备吗',
	},
	easyWlan:{
		title:'WLAN简易设置',
		text:'快捷修改WLAN用户名及密码',
		first5G:'5G优选',
		first5GMessage:'2.4G 和 5G 信号合并显示，同等信号强度下优选更快的 5G，关闭此开关，即可单独设置',
		SSID:'WLAN名称',
		SecurityPolicy:'安全政策',
		SecurityMode:'安全模式',
		WPAOption:'WPA选项',
		Passwordrules:{
			PasswordrulesText:'密码规则',
			UserNamerulesText:'用户名规则',
			rules1:'WEP模式下的字符串长度为5或13位数字.',
			rules2:'在其他模式下，字符串限制为8-32位.',
			rules3:'请输入5或13个长度的密码。请遵循密码规则。',
			rules4:'请输入长度为8-32的密码。请遵循密码规则。',
			rules5:'只允许输入 A-Z，a-z，0-9，特殊字符。',
			rules6:'SSID限制为1-32位.',
			warnMessage:'更改设置将导致Wi-Fi暂时断开连接，您可能会失去连接。如果发生这种情况，请重新连接到Wi-Fi并刷新页面。',
			successMessage:'配置成功，请使用您的新wifi凭据重新连接。'
		}
	},
	sms:{
		inbox:'收件箱',
		outbox:'发件箱',
		settings:'设置',
		newMessage:'新信息',
		phoneNumber:'电话号码',
		content:'内容',
		date:'日期',
		time:'时间',
		Recipient:'接收人',
		RemainingWords:'字数',
		sender:'发件人',
		smsCenterNumber:'信息发送号码',
		warnLimit:'长度超过限制',
		warnFill:'请填写并提交',
		warnNumber:'请填写短信号码',
	},
	dhcpSettings:{
		LANHostSettings:'局域网主机设置',
		LocalIPAddress:'本地IP地址',
		SubnetMask:'子网掩码',
		LANDHCPSettings:'局域网DHCP设置',
		DHCPServer:'DHCP服务',
		StartIP:'起始IP',
		EndIP:'结束IP',
		LeaseTime:'租期(s)',
		StaticRouteSettings:'静态路由设置',
		Index:'ID',
		DestinationIP:'目的IP',
		RouteSubnetMask:'路由子网掩码',
		Gateway:'闸道',
		warnIp1:'本地IP地址无效',
		warnSubnetMask:'子网掩码无效',
		warnStartIp:'请输入一个大于0且小于或等于255的整数',
		warnEndIp:'结束IP必须大于或等于起始IP',
		warnTime:'请填写符合条件的值',
	},
	CellSelection:{
		Priority:'优先级',
		NetworkMode:'网络模式',
	},
	LockBand:{
		TechnologyModeSetting:'技术模式设定',
	},
	CommandShell:{
		CommandRunningResults:'命令运行结果',
		Command:'命令',
		warnEmpty:'命令不能为空',
	},
	WLANStatus:{
		APInformation:'AP信息',
		SSID:'Wi-Fi名字',
		TxPower:'发射功率',
		Mode:'模式',
		Channel:'信道',
		ChannelBandwidth:'信道带宽',
		Rates:'速率',
		Security:'安全',
	},
	WLANSettings:{
		BasicSettings:'基本设置',
		Name:'网络类型',
		WLAN:'Wi-Fi',
		SSID:'Wi-Fi名字',
		CountryCode:'国家代码',
		Mode:'模式',
		ChannelBandwidth:'信道带宽',
		ChannelMode:'信道模式',
		Channel:'信道',
		TxPower:'发射功率',
		MaxSTAs:'最大STA',
		MaxLength:'最大长度',
	},
	WLANWps:{
		settings:'设置',
		WPSMode:'WPS模式',
	},
	MacFilter:{
		nodeTitle:'MAC过滤',
		MACFilterMode:'MAC过滤模式',
		WLANAccessList:'WLAN访问列表',
		warnEmpty:'此Mac地址不能为空',
		warnAddress:'此Mac地址不符合标准',
		whitelist:'白名单',
		blacklist:'黑名单',
	},
	FirewallSettings:{
		FirewallProtection:'防火墙防护',
		SPIFirewall:'SPI防火墙',
		BlockWANRequests:'阻止WAN请求',
		BlockAnonymousInternetRequests:'阻止匿名互联网请求',
		FilterIDENT:'过滤IDENT（端口113）',
	},
	Alg:{
		IPSecPassthrough:'IPSec直通',
		L2TPPassthrough:'L2TP直通',
		PPTPPassthrough:'PPTP直通',
		FTPPassthrough:'FTP直通',
		H323Passthrough:'H323直通',
		SIPPassthrough:'SIP直通',
		RTSPPassthrough:'RTSP直通',
	},
	PortForwarding:{
		PortForwardingList:'端口转发列表',
		Application:'应用',
		PortFrom:'起始端口',
		Protocol:'协议',
		IPAddress:'IP地址',
		PortTo:'目标端口',
		Enable:'使能',
		Disable:'禁用',
		Both:'全部',
	},
	Dmz:{
		DMZEnableStatus:'DMZ启用状态',
		DMZHostIPAddress:'DMZ主机IP地址',
		ExcludeWebServerPort:'排除Web服务器端口',
		ExcludeTelnetSSHPort:'排除Telnet / SSH端口',
		ExcludePingService:'排除ping服务',
	},
	Upnp:{
		UPnPConfiguration:'UPnP配置',
		UPnPService:'UPnP服务',
		UPnPNotificationInterval:'UPnP通知间隔',
		DeleteAll:'删除所有',
	},
	IPFiltering:{
		IPFilter:'IP过滤器',
		EnableIPFilter:'启用IP过滤器',
		message:'它具有过滤无线局域网[WLAN]中IP地址的功能，可用于限制用户对特定Internet服务的访问。',
		warnIp:'IP地址无效',
		maxLimit10:'上限：10',
		empty:'此IP地址不能为空',
		standard:'该IP地址不符合标准',
	},
	URLFiltering:{
		URLFilter:'地址过滤器',
		EnableURLFilter:'启用地址过滤器',
		message:'在无线局域网[WLAN]中过滤URL的功能，可用于限制用户对特定Internet服务的访问。',
		maxLimit10:'上限：10',
	},
	PortFiltering:{
		PortFilter:'端口过滤器',
		EnablePortFilter:'启用端口过滤器',
		message:'在无线局域网[WLAN]中过滤端口的功能，可用于限制用户对特定Internet服务的访问。',
		maxLimit10:'上限：10',
		PortStart:'起始端口',
		PortEnd:'结束端口',
	},
	Maintenance:{
		Reboot:'重启',
		RebootText:'单击重新启动以重新启动设备',
		FactoryReset:'恢复出厂设置',
		FactoryResetText:'单击恢复出厂设置可将设备恢复为出厂设置。',
		FactoryResetWarn:'点击恢复出厂设置按钮进行重置',
		Syslog:'系统日志',
		Download:'下载',
		Backup:'备份配置文件',
		BackupText:'要备份当前配置文件，请单击下载',
		Restore:'恢复配置文件',
		RestoreText:'要恢复配置文件，请指定本地配置文件的路径，导入文件，然后单击“上载”以恢复配置文件。',
		Upload:'上传',
	},
	DDNS:{
		DDNSService:'DDNS服务',
		UserName:'用户名',
		Password:'密码',
		HostName:'主机名',
		Status:'状态',
		InternetIPAddress:'互联网IP地址',
	},
	General:{
		ChangePassword:'更改密码',
		OldPassword:'旧密码',
		NewPassword:'新密码',
		Passwordrules:'密码规则：8-20位数字密码，必须包含大写和小写字母，数字和特殊字符',
		ReentertoConfirm:'重新输入新密码',
		TimeSettings:'时间设定',
		NTPEnableStatus:'NTP启用状态',
		TimeZone:'时区',
		SummerTimeEnable:'夏令时启用',
		NTPServer:'NTP服务器',
		UseLocalHostTime:'使用本地主机时间',
		RefreshInterval:'刷新间隔',
		minutes:'分钟',
		AutoRefresh:'自动搜寻',
		rePasswordMust:'确认新密码',
		passwordSame:'两个密码输入不一致！',
	},
	Ping:{
		PingTest:'Ping测试',
		IPProtocol:'IP协议',
	},
	Update:{
		LocalFirmwareUpdate:'本地固件升级',
		LocationText:'位置',
		ChooseFile:'选择文件',
	},
	systemTr:{
		ACSURL:'ACS地址',
		ACSUserName:'ACS用户名',
		ACSUserPassword:'ACS用户密码',
		PeriodicInform:'定期通知',
		PeriodicInformInterval:'定期通知间隔',
		PeriodicInformTime:'定期通知时间',
		RequestUserName:'要求使用者名称',
		RequestUserPassword:'要求用户密码',
	},
	Iperf:{
		IperfSettings:'Iperf设置',
		Status:'状态',
		ServerAddress:'服务器地址',
		ServerPort:'服务器端口',
		ManagementPort:'管理端口',
		MeasurementTime:'测量时间',
		Seconds:'秒',
		ProtocolType:'协议类型',
		WindowSize:'视窗尺寸',
		TCPClientNumber:'TCP客户端编号',
		DataLength:'资料长度',
		UDPBandwidth:'UDP带宽',
		UplinkSpeed:'上行速度',
		DownlinkSpeed:'下行速度',
		UplinkLatency:'上行延迟',
		DownlinkLatency:'下行延迟',
	},
	VoiceSettings:{
		RegisterStatus:'VoIP 注册状态',
		AuthorizationSatus:'授权状态',
		RegServer:'注册服务器',
		Address:'地址',
		Port:'端口',
		SIPDomain:'SIP域',
		Domain:'域',
		SIPProxy:'SIP代理',
		Enable:'使能',
		Authorization:'授权',
		AuthName:'身份验证名称',
		PhoneName:'电话名称',
		RegAccount:'注册账户',
		RegPassword:'注册密码',
	},
	DialtalMap:{
		DialPlan:'拨号方案',
	}
}
